module.exports = __webpack_public_path__ + "static/Resin Veneers smile before-e051523c88222dd8721c86fb32481861.jpg";